import { render } from "./PayrunAudienceSetting.vue?vue&type=template&id=0492437e"
import script from "./PayrunAudienceSetting.vue?vue&type=script&lang=js"
export * from "./PayrunAudienceSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__